import layoutHeaderAside from '@/layout/header-aside'
const files = require.context('./', true, /\.js$/)

let componentMaps = {
  'layoutHeaderAside': layoutHeaderAside,
  'menu': () => import(/* webpackChunkName: "menu" */'@/pages/sys/menu'),
  'route': () => import(/* webpackChunkName: "route" */'@/pages/sys/route'),
  'role': () => import(/* webpackChunkName: "role" */'@/pages/sys/role'),
  'user': () => import(/* webpackChunkName: "user" */'@/pages/sys/user'),
  'sjrr': () => import(/* webpackChunkName: "user" */'@/pages/sys/sjrr'),
  'interface': () => import(/* webpackChunkName: "interface" */'@/pages/sys/interface'),
  'card': () => import(/* webpackChunkName: "card" */'@/pages/sys/card'),
  'oneclass': () => import(/* webpackChunkName: "oneclass" */'@/pages/sys/oneclass'),
  'agent': () => import(/* webpackChunkName: "agent" */'@/pages/sys/agent'),
  'oneagent': () => import(/* webpackChunkName: "oneagent" */'@/pages/sys/oneagent'),
  'oneagenty': () => import(/* webpackChunkName: "oneagenty" */'@/pages/sys/oneagenty'),
  'oneagentd': () => import(/* webpackChunkName: "oneagentd" */'@/pages/sys/oneagentd'),
  'twoagent': () => import(/* webpackChunkName: "twoagent" */'@/pages/sys/twoagent'),
  'twoagenty': () => import(/* webpackChunkName: "twoagenty" */'@/pages/sys/twoagenty'),
  'twoagentd': () => import(/* webpackChunkName: "twoagentd" */'@/pages/sys/twoagentd'),
  'threeagent': () => import(/* webpackChunkName: "threeagent" */'@/pages/sys/threeagent'),
  'threeagenty': () => import(/* webpackChunkName: "threeagenty" */'@/pages/sys/threeagenty'),
  'threeagentd': () => import(/* webpackChunkName: "threeagentd" */'@/pages/sys/threeagentd'),
  'shops': () => import(/* webpackChunkName: "shops" */'@/pages/sys/shops'),
  'oldparts': () => import(/* webpackChunkName: "oldparts" */'@/pages/sys/oldparts'),
  'explosiveorder': () => import(/* webpackChunkName: "explosive" */'@/pages/sys/explosiveorder'),
  'explosivegood': () => import(/* webpackChunkName: "groupgood" */'@/pages/sys/explosivegood'),
  'integralgood': () => import(/* webpackChunkName: "yeargood" */'@/pages/sys/integralgood'),
  'bpruletype': () => import(/* webpackChunkName: "bpruletype" */'@/pages/sys/bpruletype'),
  'agentreply': () => import(/* webpackChunkName: "agentreply" */'@/pages/sys/agentreply'),
	 'newparts': () => import(/* webpackChunkName: "newparts" */'@/pages/sys/newparts'),
  'payparameter': () => import(/* webpackChunkName: "payparameter" */'@/pages/sys/payparameter'),
  'payconfigure': () => import(/* webpackChunkName: "payconfigure" */'@/pages/sys/payconfigure'),
  'notice': () => import(/* webpackChunkName: "notice" */'@/pages/sys/notice'),
  'uppernotice': () => import(/* webpackChunkName: "uppernotice" */'@/pages/sys/uppernotice'),
  'commission': () => import(/* webpackChunkName: "commission" */'@/pages/sys/commission'),
  'equipment': () => import(/* webpackChunkName: "equipment" */'@/pages/sys/equipment'),
  'poster': () => import(/* webpackChunkName: "poster" */'@/pages/sys/poster'),
  'videogood': () => import(/* webpackChunkName: "videogood" */'@/pages/sys/videogood'),
  'shopgl': () => import(/* webpackChunkName: "shopgl" */'@/pages/sys/shopgl'),
  'staffgl': () => import(/* webpackChunkName: "staffgl" */'@/pages/sys/staffgl'),
  'depositgl': () => import(/* webpackChunkName: "depositgl" */'@/pages/sys/depositgl'),
  'goodstype': () => import(/* webpackChunkName: "goodstype" */'@/pages/sys/goodstype'),
  'goodsgl': () => import(/* webpackChunkName: "goodsgl" */'@/pages/sys/goodsgl'),
  'order': () => import(/* webpackChunkName: "order" */'@/pages/sys/order'),
  'preview': () => import(/* webpackChunkName: "preview" */'@/pages/preview'),
  'paymentcode': () => import(/* webpackChunkName: "paymentcode" */'@/pages/sys/paymentcode'),
  'qrcode': () => import(/* webpackChunkName: "qrcode" */'@/pages/sys/qrcode'),
  'memberggl': () => import(/* webpackChunkName: "memberggl" */'@/pages/membersys/memberggl'),
  'memberprice': () => import(/* webpackChunkName: "memberprice" */'@/pages/membersys/memberprice'),
  'memberlist': () => import(/* webpackChunkName: "memberlist" */'@/pages/membersys/memberlist'),
  'smallposter': () => import(/* webpackChunkName: "smallposter" */'@/pages/sys/smallposter'),
  'imgposter': () => import(/* webpackChunkName: "imgposter" */'@/pages/sys/imgposter'),
  'selposter': () => import(/* webpackChunkName: "selposter" */'@/pages/sys/selposter'),
  'jlposter': () => import(/* webpackChunkName: "imgposter" */'@/pages/sys/jlposter'),
  'encourage': () => import(/* webpackChunkName: "encourage" */'@/pages/sys/encourage'),
  'twoclass': () => import(/* webpackChunkName: "twoclass" */'@/pages/sys/twoclass'),
  'myshops': () => import(/* webpackChunkName: "myshops" */'@/pages/sys/myshops'),
  'rakeback': () => import(/* webpackChunkName: "rakeback" */'@/pages/sys/rakeback'),
  'explosive': () => import(/* webpackChunkName: "explosive" */'@/pages/sys/explosive'),
  'couponrakeback': () => import(/* webpackChunkName: "couponrakeback" */'@/pages/sys/couponrakeback'),
  'transferaccounts': () => import(/* webpackChunkName: "transferaccounts" */'@/pages/sys/transferaccounts'),
  'agentdeploy': () => import(/* webpackChunkName: "agentdeploy" */'@/pages/sys/agentdeploy'),
  'commissionlist': () => import(/* webpackChunkName: "commissionlist" */'@/pages/sys/commissionlist'),
  'ruletype': () => import(/* webpackChunkName: "ruletype" */'@/pages/sys/ruletype'),
  'agentcomplaint': () => import(/* webpackChunkName: "agentcomplaint" */'@/pages/sys/agentcomplaint'),
  'useraddress': () => import(/* webpackChunkName: "useraddress" */'@/pages/sys/useraddress'),
  'commentlist': () => import(/* webpackChunkName: "commentlist" */'@/pages/sys/commentlist'),
  'onecity': () => import(/* webpackChunkName: "onecity" */'@/pages/sys/onecity'),
  'onecityy': () => import(/* webpackChunkName: "onecityy" */'@/pages/sys/onecityy'),
  'onecityd': () => import(/* webpackChunkName: "onecityd" */'@/pages/sys/onecityd'),
  'twocity': () => import(/* webpackChunkName: "twocity" */'@/pages/sys/twocity'),
  'twocityy': () => import(/* webpackChunkName: "twocityy" */'@/pages/sys/twocityy'),
  'twocityd': () => import(/* webpackChunkName: "twocityd" */'@/pages/sys/twocityd')
}

files.keys().forEach((key) => {
  if (key === './index.js') return
  Object.assign(componentMaps, files(key).default)
})
export default componentMaps
